import { useRef } from 'react';

/** For a Radix dialog opened without a DialogTrigger: gives focus back to what opened it, not to <body>. */
export const useReturnFocus = () => {
  const opener = useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: () => {
      opener.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    },
    onCloseAutoFocus: (event: Event) => {
      event.preventDefault();
      opener.current?.focus();
    },
  };
};
